import { Injectable } from '@angular/core';
import { AbstractDialogService } from '@examdojo/core/dialog';
import { SubmissionSpinnerDialogComponent } from './submission-spinner-dialog.component';

@Injectable()
export class SubmissionSpinnerDialogService extends AbstractDialogService<void, void> {
  readonly id = 'submission-spinner-dialog';

  protected override readonly options = {
    cssClass: 'submission-spinner-dialog auto-height',
    backdropDismiss: false,
    canDismiss: true,
    handle: false,
    showBackdrop: true,
  };

  protected override readonly component = SubmissionSpinnerDialogComponent;
}
